import script from "./TestCaseList.vue?vue&type=script&setup=true&lang=js"
export * from "./TestCaseList.vue?vue&type=script&setup=true&lang=js"

import "./TestCaseList.vue?vue&type=style&index=0&id=419bdc70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419bdc70"]])

export default __exports__